import { render, staticRenderFns } from "./observationPost.vue?vue&type=template&id=e3b7106e&"
import script from "./observationPost.vue?vue&type=script&lang=js&"
export * from "./observationPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports